import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap";
import { useParams } from "react-router-dom";
import { useGetInstence } from "../../../hooks/useGetInstence";
import { useState } from "react";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import ResultHandler from "../../../components/ResultHandler";
import { CAR_INFO_FIELDS, INFO_FIELDS, ROOM_INFO_FIELDS } from "./CONSTANT";
import { ZoomImage } from "../../../components/zoom-image/ZoomImage";
import { getReservation } from "../../../api/reservation";
import moment from "moment";
import FineTable from "./fine/FineTable";
import { formatCurrency } from "../../../utils/formatCurrency";
import PersonalUseTable from "./personal-use/PersonalUseTable";
import EditReservationAmountModal from "./EditReservationAmountModal";

export default function ReservationDetails() {
  const { reservationId } = useParams();
  const [reservation, setReservation] = useState(null);

  const { instenceLoading, instenceError, instenceSuccess, setPayload } =
    useGetInstence(getReservation, reservationId, (response) => {
      setReservation({
        ...response.data.reservation,
      });
    });

  const [reservationInfoOpen, setReservationInfoOpen] = useState("open");
  const [reservationImgOpen, setReservationImgOpen] = useState("open");
  const [fineOpen, setFineOpen] = useState("open");
  const [personalUseOpen, setPersonalUseOpen] = useState("open");

  //   Edit Amount
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="page-content company-profile-page">
        <div className="container-fluid">
          <Breadcrumb title="" breadcrumbItem={"Reservation Details"} />
          <ResultHandler loading={instenceLoading} />

          <Container fluid>
            {reservation && (
              <>
                <Row>
                  <Col md={6} lg={8}>
                    <Accordion
                      style={{ marginBottom: "20px" }}
                      open={reservationInfoOpen}
                      toggle={() =>
                        setReservationInfoOpen((i) => (i ? null : "open"))
                      }
                    >
                      <AccordionItem>
                        <AccordionHeader targetId="open">
                          <h5 className="mb-0 text-uppercase">
                            Reservation Info{" "}
                            {reservation.car_id
                              ? "(CAR)"
                              : reservation.room_id
                              ? "(ROOM)"
                              : ""}
                          </h5>
                        </AccordionHeader>
                        <AccordionBody
                          style={{ backgroundColor: "white" }}
                          accordionId="open"
                        >
                          {reservation.car_id &&
                            CAR_INFO_FIELDS.map((f) => (
                              <Row className="mb-1" key={f.key}>
                                <Col xs={6}>
                                  <Label className="mb-0">{f.label}</Label>
                                </Col>
                                <Col xs={6}>
                                  <span style={{ fontWeight: "bold" }}>
                                    {f.type == "date" && reservation.car[f.key]
                                      ? moment(reservation.car[f.key]).format(
                                          "DD MMM YYYY h:mm:ss A"
                                        )
                                      : f.type == "price"
                                      ? formatCurrency(reservation.car[f.key])
                                      : f.type == "boolean"
                                      ? reservation.car[f.key]
                                        ? "YES"
                                        : "NO"
                                      : reservation.car[f.key]}
                                  </span>
                                </Col>
                              </Row>
                            ))}

                          {reservation.room_id &&
                            ROOM_INFO_FIELDS.map((f) => (
                              <Row className="mb-1" key={f.key}>
                                {f.nested ? (
                                  f.nested.map((nf) => (
                                    <>
                                      <Col xs={6}>
                                        <Label className="mb-0">
                                          {nf.label}
                                        </Label>
                                      </Col>
                                      <Col xs={6}>
                                        <span style={{ fontWeight: "bold" }}>
                                          {reservation.room[f.key][nf.key]}
                                        </span>
                                      </Col>
                                    </>
                                  ))
                                ) : (
                                  <>
                                    <Col xs={6}>
                                      <Label className="mb-0">{f.label}</Label>
                                    </Col>
                                    <Col xs={6}>
                                      <span style={{ fontWeight: "bold" }}>
                                        {f.type == "date" &&
                                        reservation.room[f.key]
                                          ? moment(
                                              reservation.room[f.key]
                                            ).format("DD MMM YYYY h:mm:ss A")
                                          : f.type == "price"
                                          ? formatCurrency(
                                              reservation.room[f.key]
                                            )
                                          : f.type == "boolean"
                                          ? reservation.room[f.key]
                                            ? "YES"
                                            : "NO"
                                          : reservation.room[f.key]}
                                      </span>
                                    </Col>
                                  </>
                                )}
                              </Row>
                            ))}

                          {INFO_FIELDS.map((f) => (
                            <Row className="mb-1" key={f.key}>
                              <Col xs={6}>
                                <Label className="mb-0">{f.label}</Label>
                              </Col>
                              <Col xs={6}>
                                <span style={{ fontWeight: "bold" }}>
                                  {f.type == "date" && reservation[f.key]
                                    ? moment(reservation[f.key]).format(
                                        "DD MMM YYYY h:mm:ss A"
                                      )
                                    : reservation[f.key]}
                                </span>
                              </Col>
                            </Row>
                          ))}

                          {/* Renter */}
                          <Row className="mt-2 pt-2 border-top border-2">
                            <Col xs={6}>
                              <Label className="mb-0 fw-bold">
                                {reservation.employee_id
                                  ? "Employee"
                                  : reservation.admin_id
                                  ? "Admin"
                                  : reservation.contract_id
                                  ? "Company"
                                  : ""}
                              </Label>
                            </Col>
                            <Col xs={6}>
                              <span style={{ fontWeight: "bold" }}>
                                {reservation.employee_id
                                  ? reservation.employee?.name
                                  : reservation.admin_id
                                  ? reservation.admin?.name
                                  : reservation.contract_id
                                  ? reservation.contract?.company?.name
                                  : ""}
                              </span>
                            </Col>
                          </Row>

                          {/* Cost */}
                          <Row className="mt-2 pt-2 border-top border-2">
                            <Col xs={6}>
                              <Label className="mb-0 fw-bold">
                                Cost per day
                              </Label>
                            </Col>
                            <Col xs={6}>
                              <div className="d-flex justify-content-between align-items-center gap-2">
                                <span style={{ fontWeight: "bold" }}>
                                  {formatCurrency(reservation.amount)}
                                </span>
                                <Button
                                  size="sm"
                                  color="dark"
                                  className="fw-bold"
                                  onClick={() => {
                                    setShowModal(true);
                                  }}
                                >
                                  Edit
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </AccordionBody>
                      </AccordionItem>
                    </Accordion>
                  </Col>

                  <Col md={6} lg={4}>
                    <Accordion
                      style={{ marginBottom: "20px" }}
                      open={reservationImgOpen}
                      toggle={() =>
                        setReservationImgOpen((i) => (i ? null : "open"))
                      }
                    >
                      <AccordionItem>
                        <AccordionHeader targetId="open">
                          <h5 className="mb-0 text-uppercase">Picture</h5>
                        </AccordionHeader>
                        <AccordionBody
                          style={{ backgroundColor: "white" }}
                          accordionId="open"
                        >
                          {reservation.car_id && reservation.car?.picture ? (
                            <ZoomImage
                              src={reservation.car?.picture}
                              alt="car image"
                              width="100%"
                            />
                          ) : reservation.room_id &&
                            reservation.room?.picture ? (
                            <ZoomImage
                              src={reservation.room?.picture}
                              alt="room image"
                              width="100%"
                            />
                          ) : (
                            <p className="text-center my-5">No Picture Found</p>
                          )}
                        </AccordionBody>
                      </AccordionItem>
                    </Accordion>
                  </Col>
                </Row>

                {reservation.car_id && (
                  <Row>
                    <Col md={12}>
                      <Accordion
                        style={{ marginBottom: "20px" }}
                        open={fineOpen}
                        toggle={() => setFineOpen((i) => (i ? null : "open"))}
                      >
                        <AccordionItem>
                          <AccordionHeader targetId="open">
                            <h5 className="mb-0 text-uppercase">Fines</h5>
                          </AccordionHeader>
                          <AccordionBody
                            style={{ backgroundColor: "white" }}
                            accordionId="open"
                          >
                            <FineTable />
                          </AccordionBody>
                        </AccordionItem>
                      </Accordion>
                    </Col>
                  </Row>
                )}

                {reservation.car_id && (
                  <Row>
                    <Col md={12}>
                      <Accordion
                        style={{ marginBottom: "20px" }}
                        open={personalUseOpen}
                        toggle={() =>
                          setPersonalUseOpen((i) => (i ? null : "open"))
                        }
                      >
                        <AccordionItem>
                          <AccordionHeader targetId="open">
                            <h5 className="mb-0 text-uppercase">
                              Personal Use
                            </h5>
                          </AccordionHeader>
                          <AccordionBody
                            style={{ backgroundColor: "white" }}
                            accordionId="open"
                          >
                            <PersonalUseTable />
                          </AccordionBody>
                        </AccordionItem>
                      </Accordion>
                    </Col>
                  </Row>
                )}
              </>
            )}
          </Container>
        </div>
      </div>

      {showModal && (
        <EditReservationAmountModal
          reservation={reservation}
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleRefetch={() => setPayload({ ref: true })}
        />
      )}
    </>
  );
}
